/**
 * Thin, safe localStorage wrapper (pure-ish adapter).
 * Every access is guarded so private-mode / disabled storage never throws.
 */

export function getItem(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* noop */
  }
}

export function removeItem(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* noop */
  }
}

/** Read + parse JSON, returning `fallback` on any error. */
export function getJSON(key, fallback) {
  const raw = getItem(key);
  if (raw == null) return fallback;
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error('Error parsing JSON from localStorage', key, e);
    return fallback;
  }
}

export function setJSON(key, value) {
  setItem(key, JSON.stringify(value));
}
